(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bk-pdp-purchase-context"] && !Shopify.designMode) return;
  try {
    class BkQuantityPresets extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.handleNativeUpdate = this.handleNativeUpdate.bind(this);
      this.addEventListener('click', this.handleClick);
      this.closest('.product-details')?.addEventListener('quantity-selector:update', this.handleNativeUpdate);
      requestAnimationFrame(() => this.sync());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.closest('.product-details')?.removeEventListener('quantity-selector:update', this.handleNativeUpdate);
    }

    nativeSelector() {
      return this.closest('.product-details')?.querySelector(
        'product-form-component quantity-selector-component',
      );
    }

    handleClick(event) {
      const button = event.target.closest('[data-bk-quantity-preset]');
      if (!button || button.disabled) return;
      const selector = this.nativeSelector();
      const input = selector?.querySelector('input[name="quantity"]');
      const quantity = Number(button.dataset.bkQuantityPreset);
      if (!selector || !input || !Number.isInteger(quantity)) return;
      const min = Number(input.min || 1);
      const max = input.max ? Number(input.max) - Number(input.dataset.cartQuantity || 0) : Infinity;
      const step = Number(input.step || 1);
      if (quantity < min || quantity > max || (quantity - min) % step !== 0) return;
      if (typeof selector.setValue === 'function') {
        selector.setValue(String(quantity));
      } else {
        input.value = String(quantity);
      }
      if (typeof selector.onQuantityChange === 'function') {
        selector.onQuantityChange();
      } else {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (typeof selector.updateButtonStates === 'function') {
        selector.updateButtonStates();
      }
      this.sync();
    }

    handleNativeUpdate() {
      requestAnimationFrame(() => this.sync());
    }

    sync() {
      const input = this.nativeSelector()?.querySelector('input[name="quantity"]');
      if (!input) return;
      this.querySelectorAll('[data-bk-quantity-preset]').forEach((button) => {
        button.setAttribute(
          'aria-pressed',
          String(button.dataset.bkQuantityPreset === input.value),
        );
      });
    }
  }

  if (!customElements.get('bk-quantity-presets')) {
    customElements.define('bk-quantity-presets', BkQuantityPresets);
  }
  } catch(e) { console.error(e); }
})();

})();
